import * as React from 'react';
import styled from 'styled-components';
import { labelGrey } from '../appComponents/cssConstants';
import { DisplayBlockOnPrintOnly } from './PrintStyles';

const PrintOnlyField = (props: Props) => {
	return (
		<Wrapper>
			<label>{props.label}</label>
			<PrintOnlyValue>{props.value}</PrintOnlyValue>
		</Wrapper>
	);
};

export default PrintOnlyField;

interface Props {
	label: string;
	value: string | number;
}

export const PrintOnlyValue = styled.p`
	${DisplayBlockOnPrintOnly}

	font-size: 18px;
	line-height: 25px;
	min-height: 25px;
	word-break: break-word;
	text-decoration: underline;
`;

const Wrapper = styled.div`
	${DisplayBlockOnPrintOnly}

	margin-bottom: 10px;

	label {
		display: block;
		font-size: 16px;
		line-height: 23px;
		color: ${labelGrey};
	}
`;
